module.exports = __webpack_public_path__ + "img/business.d2400074.svg";